"use strict";

exports.__esModule = true;
exports.AppRoutes = AppRoutes;
var _react = _interopRequireDefault(require("react"));
var _Dashboard = require("../../Dashboard");
var _Report = require("../../Report");
var _PlantStateActivities = require("../../PlantStateActivities");
var _Device = require("../../Device");
var _User = require("../../User");
var _Alerts = require("../../Alerts");
var _Ticketing = require("../../Ticketing");
var _Calendar = require("../../Calendar");
var _AuditLog = require("../../AuditLog");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function AppRoutes() {
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Dashboard.DashboardRoutes, null), /*#__PURE__*/_react["default"].createElement(_Report.ReportRoutes, null), /*#__PURE__*/_react["default"].createElement(_PlantStateActivities.PlantStateActivitiesRoutes, null), /*#__PURE__*/_react["default"].createElement(_Device.DeviceRoutes, null), /*#__PURE__*/_react["default"].createElement(_User.UserRoutes, null), /*#__PURE__*/_react["default"].createElement(_Alerts.AlertRoutes, null), /*#__PURE__*/_react["default"].createElement(_Ticketing.TicketRoutes, null), /*#__PURE__*/_react["default"].createElement(_Calendar.CalendarRoutes, null), /*#__PURE__*/_react["default"].createElement(_AuditLog.AuditLogRoutes, null));
}